import React, { useState } from "react";
import apiClient from "../services/apiClient";

const FavoriteButton = ({ storyId }) => {
  const [isFavorite, setIsFavorite] = useState(false);

  const toggleFavorite = () => {
    const action = isFavorite ? apiClient.delete : apiClient.post;
    action(`/api/v1/favorites`, { story_id: storyId })
      .then(() => {
        setIsFavorite(!isFavorite);
      })
      .catch((error) => console.error("Error toggling favorite:", error));
  };

  return (
    <button
      onClick={toggleFavorite}
      className={`px-4 py-2 ${isFavorite ? "bg-red-500" : "bg-gray-500"} text-white rounded`}
    >
      {isFavorite ? "Unfavorite" : "Favorite"}
    </button>
  );
};

export default FavoriteButton;